export default {
    error_to_send_file: 'Erro ao enviar o arquivo. Remova-o e tente novamente.',
    download_all_files: 'Baixar todos os arquivos',
    sent_by: 'Enviado por {{name}}',
}
